<template>
  <div>
    <div class="text-xs-right">
      <v-btn icon @click="$emit('close')"> <v-icon>close</v-icon></v-btn>
    </div>
    <div class="px-4 pb-4">
      <div style="font-weight: 600; font-size: 22px" class="primary--text mb-3">
        รายละเอียดโพสต์
      </div>
      <div class="form-control" :class="{ 'has-error': errors.has('ชื่อโพสต์') }">
        <input
          v-model="input.name"
          v-validate="'required'"
          :disabled="edittype == 'read'"
          placeholder="กรอกชื่อโพสต์"
          type="text"
          name="ชื่อโพสต์"
        />
        <p v-if="errors.has('ชื่อโพสต์')" class="text-error">
          {{ errors.first('ชื่อโพสต์') }}
        </p>
      </div>
      <div class="my-3">
        <v-divider></v-divider>
      </div>
      <div class="form-control" :class="{ 'has-error': errors.has('เลือกประเภท') }">
        <v-radio-group
          v-model="radiochannel"
          v-validate="'required'"
          :disabled="edittype == 'read' || IsPublished"
          row
          name="เลือกประเภท"
        >
          <v-radio label="เลือกเพจทั้งหมด" value="all" color="primary"></v-radio>
          <v-radio label="เลือกเฉพาะเพจ" value="custom" color="primary"></v-radio>
        </v-radio-group>
        <p v-if="errors.has('เลือกประเภท')" class="text-error">
          {{ errors.first('เลือกประเภท') }}
        </p>
      </div>
      <div class="mb-3">
        <div
          v-if="radiochannel == 'custom'"
          class="form-control"
          :class="{ 'has-error': errors.has('เลือกกลุ่ม') }"
        >
          <multiselect
            :loading="loadinggroup"
            :disabled="edittype == 'read' || IsPublished"
            placeholder="เลือกกลุ่ม"
            name="เลือกกลุ่ม"
            track-by="id"
            label="name"
            :options="groupOptionsFiltered"
            :show-labels="false"
            :custom-label="customLabel"
            @input="onChangeGroup"
          >
          </multiselect>
          <p v-if="errors.has('เลือกกลุ่ม')" class="text-error">
            {{ errors.first('เลือกกลุ่ม') }}
          </p>
        </div>
      </div>
      <div>
        <div
          v-if="radiochannel == 'custom'"
          class="form-control"
          :class="{ 'has-error': errors.has('เลือกเพจ') }"
        >
          <multiselect
            :key="keychannels"
            v-model="input.channellist"
            v-validate="'required'"
            :disabled="edittype == 'read' || IsPublished"
            placeholder="เลือกเพจ"
            name="เลือกเพจ"
            track-by="channelid"
            label="channelname"
            :options="filteredChannels"
            multiple
            :show-labels="false"
            @remove="keychannels++"
            @select="handleSelectChannelList"
          >
          </multiselect>
          <p v-if="errors.has('เลือกเพจ')" class="text-error">
            {{ errors.first('เลือกเพจ') }}
          </p>
        </div>
      </div>
      <div class="form-control mt-4" :class="{ 'has-error': errors.has('คำบรรยาย') }">
        <textarea
          v-model="input.messages"
          v-validate="'required'"
          :disabled="edittype == 'read'"
          class="form-control"
          rows="5"
          name="คำบรรยาย"
          style="resize: vertical; min-height: 90px"
          :placeholder="'เพิ่มคำบรรยาย'"
        ></textarea>
        <p v-if="errors.has('คำบรรยาย')" class="text-error">
          {{ errors.first('คำบรรยาย') }}
        </p>
      </div>
      <div class="mb-3">
        <v-checkbox
          v-model="input.signaturestatus"
          :disabled="edittype == 'read'"
          :label="`ใช้ Signature`"
        ></v-checkbox>
      </div>
      <div v-if="edittype != 'read'" class="mb-4">
        <v-btn
          class="mr-2"
          :color="selectedPostMode == 'image' ? 'primary' : 'gray'"
          large
          @click="choosePostMode('image')"
          >โพสต์รูป</v-btn
        >
        <v-btn
          :color="selectedPostMode == 'video' ? 'primary' : 'gray'"
          large
          @click="choosePostMode('video')"
          >โพสต์วีดีโอ</v-btn
        >
      </div>
      <div v-if="selectedPostMode != ''" class="mb-3">
        <UploadMultipleFile
          v-model="input.photoUrl"
          :max="maxUpload"
          :readonly="edittype == 'read'"
          data-vv-name="uploadMultipleFile"
          data-vv-as="Preview Image"
          :display-type="selectedPostMode"
        ></UploadMultipleFile>
      </div>
      <div :style="edittype == 'read' ? 'pointer-events: none;' : ''">
        <div>ตั้งเวลาโพสต์</div>
        <div>
          <v-layout row wrap class="ma-0">
            <v-flex xs4>
              <DatepickerCustomDialog v-model="selectedDate" class="form-control">
                <input
                  placeholder="DD/MM/YYYY"
                  readonly
                  :value="getDateFormatted(selectedDate)"
                  type="text"
                />
              </DatepickerCustomDialog>
            </v-flex>
            <v-flex xs3 class="pl-2">
              <CustomTimepicker v-model="selectedTime" class="form-control">
                <input placeholder="00:00" readonly :value="selectedTime" type="text" />
              </CustomTimepicker>
            </v-flex>
            <v-flex v-if="edittype != 'read'">
              <v-btn icon @click="clearDateTime"> <v-icon>close</v-icon></v-btn>
            </v-flex>
          </v-layout>
        </div>
      </div>
      <div v-if="edittype !== 'read'" class="text-xs-center">
        <v-btn outline color="grey" @click="$emit('close')">ยกเลิก</v-btn>
        <v-btn
          v-if="edittype == 'create' || (editdata && editdata.postaction != 'published')"
          :loading="saveloading"
          outline
          color="grey"
          @click="onSave(false)"
          >บันทึกฉบับร่าง</v-btn
        >
        <v-btn :loading="saveloading" depressed color="primary" @click="onSave(true)">
          โพสต์
        </v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import UploadMultipleFile from './UploadMultipleFile.vue'
import multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import CustomTimepicker from '@/components/elements/CustomTimepicker.vue'
import DatepickerCustomDialog from '@/components/elements/DatepickerCustomDialog.vue'
import moment from 'moment'
export default {
  name: 'FacebookPostManager',
  components: {
    multiselect,
    UploadMultipleFile,
    DatepickerCustomDialog,
    CustomTimepicker
  },
  props: ['edittype', 'editdata', 'channels', 'groupOptions', 'loadinggroup', 'IsPublished'],
  computed: {
    groupOptionsFiltered() {
      if (this.groupOptions && this.groupOptions.length) {
        return this.groupOptions.map((group) => {
          var channels = this.filteredChannels.filter((val) =>
            val.groupids ? val.groupids.includes(parseInt(group.id)) : false
          )
          return {
            ...group,
            total: channels.length,
            $isDisabled: channels.length == 0
          }
        })
      } else return []
    },
    ...mapGetters(['selectedBot']),
    filteredChannels() {
      this.keychannels++
      return this.channels.filter((el) => {
        return el.app == 'facebook'
      })
    }
  },
  data() {
    return {
      keychannels: 0,
      saveloading: false,
      radiochannel: '',
      selectedGroup: '',
      input: {
        name: '',
        photoUrl: [],
        channellist: []
      },
      selectedDate: '',
      selectedTime: '',
      selectedPostMode: '',
      scheduleTime: '',
      maxUpload: 0
    }
  },
  mounted() {
    if (this.edittype == 'edit' || this.edittype == 'read') {
      this.input = this.editdata
      if (this.editdata.photourl && !this.editdata.attachmedia) {
        // Old structure
        let photos = this.editdata.photourl.split(',')
        if (photos && photos.length > 0) {
          let photosModel = []
          photos.forEach((p) => {
            photosModel.push({ url: p, type: 'image' })
          })
          this.selectedPostMode = 'image'
          this.maxUpload = 50
          this.input.photoUrl = photosModel
        }
      } else {
        if (this.editdata.posttype) {
          this.selectedPostMode = this.editdata.posttype
          this.input.photoUrl = this.editdata.attachmedia
          this.maxUpload = this.selectedPostMode == 'image' ? 50 : 1
        } else {
          this.selectedPostMode = 'message'
        }
        this.input.photoUrl = this.editdata.attachmedia
      }

      if (this.editdata.scheduletime) {
        const tempScheduleTime = this.editdata.scheduletime
        // const formatScheduleTime = moment(tempScheduleTime).format('YYYY-MM-DD HH:mm')
        const formatScheduleTime = moment(tempScheduleTime)
        // const splitDateTime = formatScheduleTime.split(' ')

        this.selectedDate = formatScheduleTime.format('YYYY-MM-DD')
        this.selectedTime = formatScheduleTime.format('HH:mm')
      }

      this.radiochannel = 'custom'

      this.input.channellist = this.filteredChannels.filter((el) => {
        return this.editdata.channelidlist.includes(el.channelid)
      })
      this.keychannels++
      this.input.signaturestatus = this.editdata.signaturestatus
    } else {
      this.input.signaturestatus = true
    }
  },
  methods: {
    handleSelectChannelList() {
      this.$nextTick()
      this.keychannels++
    },
    customLabel(item) {
      return `${item.name} (${item.total})`
    },
    onChangeGroup(group) {
      this.input.channellist = this.filteredChannels.filter((el) =>
        el.groupids ? el.groupids.includes(parseInt(group.id)) : false
      )
      this.keychannels++
    },
    async onSave(isPublish) {
      if (await this.$validator.validate()) {
        if (this.edittype == 'create') {
          this.createData(isPublish)
        } else {
          this.editData(isPublish)
        }
      }
    },
    async sendPost(data) {
      if (data.scheduleTime) {
        let IsValid = await this.checkScheduleime(data.scheduleTime)
        if (!IsValid) {
          return
        }
      }

      api.powerbuySendFacebookPost(data, (err, response) => {
        this.saveloading = false
        if (response.responsecode == 200) {
          this.$emit('onSave')
        }
      })
    },
    async createData(isPublish) {
      this.saveloading = true
      if (this.radiochannel == 'all') {
        var channelIdList = this.filteredChannels.map((el) => el.channelid)
      } else {
        var channelIdList = this.input.channellist.map((el) => el.channelid)
      }

      // Find post type
      let postType = 'message'
      let photos = ''
      let attachmentMedia = []
      if (this.input.photoUrl && this.input.photoUrl.length > 0) {
        // Have content attachment
        // Find image
        const images_arr = this.input.photoUrl.filter((f) => f.type == 'image')
        const video_arr = this.input.photoUrl.filter((f) => f.type == 'video')
        if (this.selectedPostMode == 'image' && images_arr && images_arr.length > 0) {
          postType = 'image'
          attachmentMedia = images_arr
          photos = images_arr.map((p) => p.url).join(',')
        } else if (this.selectedPostMode == 'video' && video_arr.length > 0) {
          // If not found image, so it's video
          attachmentMedia = video_arr
          postType = 'video'
        }
      }

      if (this.selectedDate) {
        this.scheduleTime = moment(this.selectedDate).format('YYYY-MM-DD')
        this.scheduleTime += ' ' + (this.selectedTime ? this.selectedTime + ':00' : '00:00:00')

        // Check schedule time before create post (zwiz)
        let IsValid = await this.checkScheduleime(this.scheduleTime)
        if (!IsValid) {
          return
        }
      }

      var data = {
        pageid: this.selectedBot.pageid,
        name: this.input.name,
        channelIdList, // array channelid
        messages: this.input.messages,
        photoUrl: photos,
        scheduleTime: this.scheduleTime,
        postType,
        attachmedia: attachmentMedia,
        publish: isPublish, // boolean >> true คือโพสต์ไป facebook, false คือ แบบร่าง
        signatureStatus: this.input.signaturestatus
      }

      api.powerbuyCreateFacebookPost(data, async (err, response) => {
        if (response.responsecode == 200) {
          data.postId = response.data[0].id
          if (isPublish) {
            await this.sendPost(data)
          } else {
            this.saveloading = false
            this.$emit('onSave')
          }
        }
      })
    },
    async editData(isPublish) {
      this.saveloading = true
      if (this.radiochannel == 'all') {
        var channelIdList = this.filteredChannels.map((el) => el.channelid)
      } else {
        var channelIdList = this.input.channellist.map((el) => el.channelid)
      }

      // Find post type
      let postType = 'message'
      let photos = ''
      let attachmentMedia = []
      if (this.input.photoUrl && this.input.photoUrl.length > 0) {
        // Have content attachment
        // Find image
        const images_arr = this.input.photoUrl.filter((f) => f.type == 'image')
        const video_arr = this.input.photoUrl.filter((f) => f.type == 'video')
        if (this.selectedPostMode == 'image' && images_arr && images_arr.length > 0) {
          postType = 'image'
          attachmentMedia = images_arr
          photos = images_arr.map((p) => p.url).join(',')
        } else if (this.selectedPostMode == 'video' && video_arr.length > 0) {
          // If not found image, so it's video
          attachmentMedia = video_arr
          postType = 'video'
        }
      }

      if (this.selectedDate) {
        this.scheduleTime = moment(this.selectedDate).format('YYYY-MM-DD')
        this.scheduleTime += ' ' + (this.selectedTime ? this.selectedTime + ':00' : '00:00:00')

        let IsValid = await this.checkScheduleime(this.scheduleTime)
        if (!IsValid) {
          return
        }
      }

      var data = {
        id: this.editdata.id,
        postId: this.editdata.id,
        pageid: this.selectedBot.pageid,
        name: this.input.name,
        channelIdList, // array channelid
        messages: this.input.messages,
        photoUrl: photos,
        scheduleTime: this.scheduleTime,
        postType,
        attachmedia: attachmentMedia,
        publish: isPublish, // boolean >> true คือโพสต์ไป facebook, false คือ แบบร่าง
        signatureStatus: this.input.signaturestatus // boolean >> true คือโพสต์ไป facebook, false คือ แบบร่าง
      }

      if (['published', 'edited'].includes(this.editdata.postaction)) {
        this.saveloading = false
        await this.editPublishedPost(data)
      } else {
        // Edit zwiz post
        api.powerbuyEditFacebookPost(data, async (err, response) => {
          if (isPublish) {
            await this.sendPost(data)
          } else {
            this.saveloading = false
            this.$emit('onSave')
          }
        })
      }
    },
    getDateFormatted(val) {
      if (val) {
        return moment(val).format('DD/MM/YYYY')
      } else return ''
    },
    clearDateTime() {
      this.selectedDate = ''
      this.selectedTime = ''
    },
    choosePostMode(type) {
      this.selectedPostMode = type
      this.maxUpload = type == 'image' ? 50 : 1
    },
    async editPublishedPost(data) {
      await this.$swal
        .fire({
          title: this.$t('คุณต้องการจะแก้ไขโพสต์ใช่หรือไม่'),
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: this.$t('Confirm'),
          cancelButtonText: this.$t('cancel'),
          reverseButtons: true
        })
        .then(async (result) => {
          if (result.value) {
            this.saveloading = true
            // Check schedule time (If any)
            if (data.scheduleTime) {
              let IsValid = await this.checkScheduleime(data.scheduleTime)
              if (!IsValid) {
                return
              }
            }

            this.saveloading = true
            // Edit content on published post
            api.powerbuyEditFacebookPublishPost(data, (err, response) => {
              this.saveloading = false
              this.$emit('onSave')
            })
          }
        })
    },
    async checkScheduleime(scheduleTime) {
      // Check current time with schedule time (If any)
      // Schedule time is more than current about 20 minutes
      let status = false
      if (scheduleTime) {
        let diff = moment(scheduleTime).diff(moment(), 'minutes')
        if (diff < 20) {
          this.$swal.fire({
            title: 'ไม่สามารถดำเนินการได้',
            text: 'เนื่องจากเวลาในการโพสต์ต้องมากกว่าเวลาปัจจุบันอย่างน้อย 20 นาที',
            type: 'error'
          })
          this.saveloading = false
        } else {
          status = true
        }
      }
      return status
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/powerbuy/FacebookPostManager/PostEdit.vue